import { Component, computed, input, signal } from '@angular/core';

@Component({
  selector: 'app-tenant-logo',
  host: { class: 'contents' },
  template: `
    @if (src(); as imageUrl) {
      <div class="flex h-full max-w-full items-center justify-center overflow-hidden rounded-lg dark:bg-white dark:p-1.5">
        <img [src]="imageUrl" alt="Logo del tenant" class="max-h-full max-w-full object-contain" [class]="imgClass()" (error)="onError()" />
      </div>
    } @else {
      <span [class]="fallbackClass()" [style]="fallbackStyle()">{{ fallbackText() }}</span>
    }
  `
})
export class TenantLogoComponent {
  readonly logoUrl = input<string | null | undefined>(null);
  readonly fallbackText = input('');
  readonly imgClass = input('h-8 w-auto');
  readonly fallbackClass = input('');
  readonly fallbackStyle = input('');

  private readonly failedLogoUrl = signal<string | null>(null);

  readonly src = computed(() => {
    const url = this.logoUrl()?.trim();
    return url && this.failedLogoUrl() !== url ? url : null;
  });

  onError(): void {
    const url = this.logoUrl()?.trim();
    if (url) this.failedLogoUrl.set(url);
  }
}
